import React from "react";

/**
 * SectionError — 섹션 단위 부분 실패 표시용 공통 컴포넌트.
 *
 * 백엔드가 병렬 개발 중이라 개별 API 호출이 실패해도 페이지 전체가 깨지지
 * 않아야 한다(DAS-164). 각 섹션은 자신의 에러만 이 컴포넌트로 표시하고
 * 나머지 섹션은 정상 렌더를 유지한다.
 */
function SectionError({ message = "데이터를 불러오지 못했습니다.", onRetry }) {
    return (
        <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-surface-border bg-surface-card-alt px-4 py-8 text-center">
            <svg
                aria-hidden="true"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                className="h-8 w-8 text-content-muted"
            >
                <circle cx="12" cy="12" r="9" />
                <path d="M12 8v5" />
                <path d="M12 16h.01" />
            </svg>
            <p className="text-xs text-content-muted">{message}</p>
            {onRetry && (
                <button
                    type="button"
                    onClick={onRetry}
                    className="mt-1 min-h-[44px] rounded-lg border border-surface-border px-3 text-xs font-medium text-content-secondary hover:bg-surface-hover"
                >
                    다시 시도
                </button>
            )}
        </div>
    );
}

export default SectionError;
